export enum RedemptionSource {
    Customer = 0,
    Taurus = 1,
    Gjeldsregisteret = 2,
    NorskGjeldsinformasjon = 3
}
